import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { initDb, checkAndSwitchMode, fixMissingTimestamps } from './lib/db';
import { config } from './lib/config';
import { AppProvider } from './lib/AppContext';
import toast from 'react-hot-toast';

async function init() {
  const root = createRoot(document.getElementById('root')!);
  
  // Afficher les informations de démarrage
  console.log('Démarrage de l\'application...');
  console.log('URL Supabase initiale:', config.supabase.url);
  console.log('Table:', 'lotismode_products');
  console.log('Mode démo:', localStorage.getItem('demoMode') === 'true' ? 'Activé' : 'Désactivé');
  
  try {
    // Charger les configurations de connexion
    const savedConnectionsJson = localStorage.getItem('saved_connections');
    let connections = [];
    
    if (savedConnectionsJson) {
      try {
        connections = JSON.parse(savedConnectionsJson);
        const activeConnection = connections.find((c: any) => c.isActive);
        
        if (activeConnection) {
          console.log('Connexion active trouvée:', activeConnection.connectionName);
          
          // Mettre à jour localStorage avec la connexion active
          localStorage.setItem('connection_name', activeConnection.connectionName || '');
          localStorage.setItem('supabase_url', activeConnection.supabaseUrl);
          localStorage.setItem('supabase_anon_key', activeConnection.supabaseAnonKey);
        }
      } catch (error) {
        console.error('Erreur lors du chargement des connexions sauvegardées:', error);
      }
    }
    
    // Initialiser la connexion à la base de données
    const isConnected = await initDb();
    
    if (!isConnected) {
      console.log('L\'application fonctionnera en mode hors-ligne');
    } else {
      // Si la connexion est établie, corriger les timestamps manquants
      await fixMissingTimestamps();
    }
    
    // Vérifier périodiquement si on peut basculer de mode
    setInterval(checkAndSwitchMode, 60000); // Vérifier toutes les minutes
  } catch (error) {
    console.error('Erreur lors de l\'initialisation:', error);
    toast.error('Erreur d\'initialisation. Mode hors-ligne activé.');
  }
  
  // Rendu de l'application
  root.render(
    <StrictMode>
      <AppProvider>
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10B981',
                secondary: 'white',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#EF4444',
                secondary: 'white',
              },
            },
          }} 
        />
      </AppProvider>
    </StrictMode>
  );
}

init();